<template>
  <div class="min-h-screen flex flex-col">
    <Header />
    <main class="flex-grow flex flex-col">
      <slot />
    </main>
    <Footer />
  </div>
</template>
